/* Ambrosi & Sons — interactions */
(function () {
  "use strict";

  /* ---- Mobile nav toggle ---- */
  var toggle = document.getElementById("nav-toggle");
  var nav = document.getElementById("main-nav");
  var navOverlay = document.getElementById("nav-overlay");
  var navClose = document.getElementById("nav-close");
  if (toggle && nav) {
    var setNav = function (open) {
      nav.classList.toggle("is-open", open);
      toggle.classList.toggle("is-active", open);
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      if (navOverlay) navOverlay.classList.toggle("is-open", open);
      document.documentElement.classList.toggle("amb-nav-open", open);
    };
    toggle.addEventListener("click", function () {
      setNav(!nav.classList.contains("is-open"));
    });
    if (navOverlay) navOverlay.addEventListener("click", function () { setNav(false); });
    if (navClose) navClose.addEventListener("click", function () { setNav(false); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && nav.classList.contains("is-open")) setNav(false);
    });
    // close on link click (mobile)
    nav.addEventListener("click", function (e) {
      if (e.target.closest("a") && nav.classList.contains("is-open")) setNav(false);
    });
  }

  /* ---- Sticky header on scroll ---- */
  var header = document.getElementById("site-header");
  if (header) {
    var onScroll = function () {
      header.classList.toggle("is-stuck", window.scrollY > 120);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---- Gallery carousel (infinite loop) ---- */
  var track = document.getElementById("gallery-track");
  if (track) {
    var buttons = document.querySelectorAll(".gallery__btn");
    var originals = Array.prototype.slice.call(track.children);

    var step = function () {
      var slide = track.querySelector(".gallery__slide");
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || "24") || 24;
      return slide ? slide.getBoundingClientRect().width + gap : 320;
    };
    // width of one full set of the original slides
    var setWidth = function () { return step() * originals.length; };

    // set scrollLeft without the CSS smooth animation (for the seamless wrap jump)
    var jumpTo = function (x) {
      var prev = track.style.scrollBehavior;
      track.style.scrollBehavior = "auto";
      track.scrollLeft = x;
      track.style.scrollBehavior = prev || "";
    };

    // Build the infinite strip: [clone set] [originals] [clone set].
    // Because the three sets are identical, jumping by one set-width is invisible.
    if (originals.length > 1) {
      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      originals.forEach(function (node) {
        var c1 = node.cloneNode(true), c2 = node.cloneNode(true);
        c1.classList.add("is-clone"); c1.setAttribute("aria-hidden", "true");
        c2.classList.add("is-clone"); c2.setAttribute("aria-hidden", "true");
        before.appendChild(c1);
        after.appendChild(c2);
      });
      track.appendChild(after);
      track.insertBefore(before, track.firstChild);
      // start inside the real middle set
      requestAnimationFrame(function () { jumpTo(setWidth()); });
    }

    // Keep the scroll position within the middle set; wrap seamlessly at the edges.
    var normalize = function () {
      if (originals.length <= 1) return;
      var w = setWidth();
      if (track.scrollLeft >= 2 * w - 1) jumpTo(track.scrollLeft - w);
      else if (track.scrollLeft < w - 1) jumpTo(track.scrollLeft + w);
    };
    var scrollEndTimer = null;
    track.addEventListener("scroll", function () {
      clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(normalize, 80);
    }, { passive: true });

    var advance = function (dir) {
      track.scrollBy({ left: dir * step(), behavior: "smooth" });
    };

    // Enable scroll-snap only once the user touches the carousel. Snapping at
    // load time makes the compositor scroll the track before first paint, and
    // Chrome then stops reporting Largest Contentful Paint (PageSpeed "NO_LCP").
    var enableSnap = function () { track.classList.add("is-snap"); };
    ["pointerdown", "touchstart", "wheel", "keydown"].forEach(function (ev) {
      track.addEventListener(ev, enableSnap, { passive: true, once: true });
    });

    buttons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var dir = parseInt(btn.getAttribute("data-dir"), 10) || 1;
        advance(dir);
      });
    });

    /* ---- Auto-advance ---- */
    var galleryTimer = null;
    var startAuto = function () {
      clearInterval(galleryTimer);
      galleryTimer = setInterval(function () { advance(1); }, 4000);
    };
    startAuto();
    // pause while the user is hovering or interacting, then resume
    ["mouseenter", "focusin", "touchstart"].forEach(function (ev) {
      track.addEventListener(ev, function () { clearInterval(galleryTimer); }, { passive: true });
    });
    ["mouseleave", "focusout", "touchend"].forEach(function (ev) {
      track.addEventListener(ev, startAuto, { passive: true });
    });
    buttons.forEach(function (btn) {
      btn.addEventListener("click", startAuto);
    });
  }

  /* ---- Hero slider (fade) ---- */
  var hslider = document.querySelector(".hero-slider");
  if (hslider) {
    var hslides = hslider.querySelectorAll(".hero");
    var hdots = hslider.querySelectorAll(".hero-slider__dot");
    var hn = hslides.length;
    var hi = 0;
    var htimer = null;
    var hauto = parseInt(hslider.getAttribute("data-autoplay"), 10) || 0;

    var hgo = function (i) {
      hi = (i + hn) % hn;
      for (var k = 0; k < hn; k++) hslides[k].classList.toggle("is-active", k === hi);
      for (var d = 0; d < hdots.length; d++) hdots[d].classList.toggle("is-active", d === hi);
    };
    var hreset = function () {
      if (hauto && hn > 1) {
        clearInterval(htimer);
        htimer = setInterval(function () { hgo(hi + 1); }, hauto);
      }
    };

    if (hn > 1) {
      hslider.querySelectorAll("[data-hero-dir]").forEach(function (b) {
        b.addEventListener("click", function () {
          hgo(hi + (parseInt(b.getAttribute("data-hero-dir"), 10) || 1));
          hreset();
        });
      });
      hdots.forEach(function (dot) {
        dot.addEventListener("click", function () {
          hgo(parseInt(dot.getAttribute("data-hero-go"), 10) || 0);
          hreset();
        });
      });
      hreset();
    }
  }

  /* ---- Lightbox for gallery / slider images ---- */
  var galleryTracks = document.querySelectorAll(".gallery__track");
  if (galleryTracks.length) {
    var lb, lbImg, lbCap, lbCount, lbState = { list: [], i: 0 };

    var lbRender = function () {
      var item = lbState.list[lbState.i];
      if (!item) return;
      lbImg.src = item.src;
      lbImg.alt = item.alt || "";
      lbCap.textContent = item.alt || "";
      lbCap.style.display = item.alt ? "" : "none";
      lbCount.textContent = (lbState.i + 1) + " / " + lbState.list.length;
      var multi = lbState.list.length > 1;
      lb.querySelectorAll(".amb-lightbox__nav").forEach(function (n) { n.style.display = multi ? "" : "none"; });
      lbCount.style.display = multi ? "" : "none";
    };
    var lbNav = function (d) {
      var n = lbState.list.length;
      if (n) { lbState.i = (lbState.i + d + n) % n; lbRender(); }
    };
    var lbClose = function () {
      if (lb) { lb.classList.remove("is-open"); document.documentElement.style.overflow = ""; }
    };
    var lbBuild = function () {
      lb = document.createElement("div");
      lb.className = "amb-lightbox";
      lb.setAttribute("role", "dialog");
      lb.setAttribute("aria-modal", "true");
      lb.innerHTML =
        '<button class="amb-lightbox__close" aria-label="Close">×</button>' +
        '<button class="amb-lightbox__nav amb-lightbox__nav--prev" aria-label="Previous">‹</button>' +
        '<figure class="amb-lightbox__stage"><img class="amb-lightbox__img" alt=""><figcaption class="amb-lightbox__cap"></figcaption></figure>' +
        '<button class="amb-lightbox__nav amb-lightbox__nav--next" aria-label="Next">›</button>' +
        '<div class="amb-lightbox__count"></div>';
      document.body.appendChild(lb);
      lbImg = lb.querySelector(".amb-lightbox__img");
      lbCap = lb.querySelector(".amb-lightbox__cap");
      lbCount = lb.querySelector(".amb-lightbox__count");
      lb.addEventListener("click", function (e) {
        if (e.target === lb || e.target.closest(".amb-lightbox__close")) lbClose();
        else if (e.target.closest(".amb-lightbox__nav--prev")) lbNav(-1);
        else if (e.target.closest(".amb-lightbox__nav--next")) lbNav(1);
      });
    };
    var lbOpen = function (list, i) {
      if (!lb) lbBuild();
      lbState.list = list;
      lbState.i = i;
      lbRender();
      lb.classList.add("is-open");
      document.documentElement.style.overflow = "hidden";
    };

    document.addEventListener("keydown", function (e) {
      if (!lb || !lb.classList.contains("is-open")) return;
      if (e.key === "Escape") lbClose();
      else if (e.key === "ArrowLeft") lbNav(-1);
      else if (e.key === "ArrowRight") lbNav(1);
    });

    galleryTracks.forEach(function (track) {
      // Build the image list from the real (non-clone) slides, in order.
      var list = Array.prototype.slice.call(track.children)
        .filter(function (s) { return !s.classList.contains("is-clone"); })
        .map(function (s) {
          var img = s.querySelector("img");
          return img ? { src: img.getAttribute("data-full") || img.currentSrc || img.src, alt: img.getAttribute("alt") || "" } : null;
        })
        .filter(function (x) { return x && x.src; });
      if (!list.length) return;

      track.addEventListener("click", function (e) {
        var slide = e.target.closest(".gallery__slide");
        if (!slide || !track.contains(slide)) return;
        // map DOM position (incl. clones) back to the original image index
        var di = Array.prototype.slice.call(track.children).indexOf(slide);
        var idx = ((di % list.length) + list.length) % list.length;
        lbOpen(list, idx);
      });
    });
  }
})();
